import { IPublishTerms } from './publishTerms';

export interface IPublishTermsState extends IPublishTerms {
  /** Статус загрузки услуг размещения */
  status: EPublishTermsStatus;
  /** Ошибка сервера */
  error: string | null;
}

export enum EPublishTermsStatus {
  initial = 'initial',
  pending = 'pending',
  success = 'success',
  fail = 'fail',
}
